import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";

/* ─── Shared helpers used by every project sub-tab panel ─────────── */

export function PanelHeader({ icon: Icon, title, subtitle, action }) {
  return (
    <div className="mb-2 flex items-start justify-between gap-3">
      <div>
        <div className="flex items-center gap-1.5 font-semibold text-sm text-slate-900">
          {Icon && <Icon size={13} className="text-[#1E5CBA]" />} {title}
        </div>
        {subtitle && <div className="text-[11px] text-slate-500 mt-0.5">{subtitle}</div>}
      </div>
      {action}
    </div>
  );
}

export function EmptyHint({ message }) {
  return (
    <div className="rounded-md border border-dashed border-slate-300 bg-white p-3 text-center text-[11px] text-slate-500">
      {message}
    </div>
  );
}

export function Tile({ k, v }) {
  return (
    <div className="rounded-md border border-slate-200 bg-white px-2.5 py-2">
      <div className="font-mono-alt text-[10px] uppercase tracking-wider text-slate-500">{k}</div>
      <div className="mt-0.5 font-display text-base font-bold text-slate-900 tabular-nums">{v}</div>
    </div>
  );
}

/** Generic list fetcher hook with consistent error/loading shape. */
export function useFetchList(endpoint, deps = []) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);
  useEffect(() => {
    let alive = true;
    (async () => {
      setLoading(true);
      try {
        const { data } = await api.get(endpoint);
        if (!alive) return;
        const arr = Array.isArray(data) ? data : (data?.items || data?.snapshots || []);
        setItems(arr);
        setErr(null);
      } catch (e) {
        if (alive) setErr(formatApiError(e));
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  return { items, loading, err };
}
